import React from 'react';
import moment from 'moment';
import { RouteStationCheckout, RouteStationText } from './styles';

export default function RouteStation({ station, column }) {
  return (
    <RouteStationText
      title={
        station.checkout &&
        `checkout realizado às ${moment(station.checkout).format('DD/MM/YYYY HH:mm')}`
      }
      style={column?.componentStyles}
    >
      {station.checkout && <RouteStationCheckout />}
      {station.name}
    </RouteStationText>
  );
}
